import * as React from 'react';
import { ListingItem } from './listingItem';
import { Button } from './button';
export function NewsArchive(props) {
    var _a = React.useState([]), items = _a[0], setItems = _a[1];
    var _b = React.useState(false), loadMorePossible = _b[0], setLoadMorePossible = _b[1];
    var itemThreshold = 8;
    React.useEffect(function () {
        if (props.items.length > itemThreshold) {
            var newItemsArr = props.items.slice(0, itemThreshold);
            setItems(newItemsArr);
            setLoadMorePossible(true);
            return;
        }
        setItems(props.items);
    }, []);
    var handleLoadMore = function () {
        setItems(props.items);
        setLoadMorePossible(false);
    };
    return (React.createElement("div", { className: 'autonet-news-listing autonet-listing element-flex' },
        items.map(function (item) {
            return React.createElement(ListingItem, { key: item.contentId, item: item });
        }),
        loadMorePossible &&
            React.createElement(Button, { onClick: handleLoadMore, style: 'default', title: props.loadMoreLabel, label: props.loadMoreLabel, alignment: 'align-center' })));
}
